import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSerialType(params) {
	return client.get("member/serial/type", {
		params: params,
	});
}

function getSerialStarList(params) {
	return client.get("member/serial/stock/1", {
		params: params,
	});
}

function getSerialEliteList(params) {
	return client.get("member/serial/stock/2", {
		params: params,
	});
}

function getSerialEkonomiList(params) {
	return client.get("member/serial/stock/3", {
		params: params,
	});
}

function getSerialCeriaList(params) {
	return client.get("member/serial/stock/4", {
		params: params,
	});
}

function getSerialSupremeList(params) {
	return client.get("member/serial/stock/5", {
		params: params,
	});
}

function getSerialROList(params) {
	return client.get("member/serial/stock/5", {
		params: params,
	});
}

function sendSerial(params) {
	return client.post("member/serial/send", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getHistorySerialList(params) {
	return client.get(`member/serial/history/${params.id}`, {	
		params: params.params,
	});
}

function getDetailHistorySerialList(params) {
	return client.get(`member/serial/detail_history/${params.id}`, {	
		params: params.params,
	});
}

function getSerialAvailList(params) {
	return client.get("member/serial/stockavailable", {
		params: params,
	});
}

function getHistoryTransaksiSerial(params) {
	return client.get(`member/serial/used_history/${params.id}`, {	
		params: params.params,
	});
}

function getNewOTP(params) {
	return client.post("member/otp/", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function verifyOTP(params) {
	return client.post("member/verify/otp/", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getSerialType,
	getSerialStarList,
	getSerialEliteList,
	getSerialEkonomiList,
	getSerialCeriaList,
	getSerialSupremeList,
	getSerialROList,
	sendSerial,
	getHistorySerialList,
	getDetailHistorySerialList,
	getSerialAvailList,
	getHistoryTransaksiSerial,

	getNewOTP,
	verifyOTP
};